export const languages = [
  {
    name: 'English',
    code: 'en',
    flag:
      'https://cdn.jsdelivr.net/gh/weglot/languages@1.6.0/images/flag-icon-css/4x3/us.svg',
  },
  {
    name: 'Arabic',
    code: 'ar',
    flag:
      'https://cdn.jsdelivr.net/gh/weglot/languages@1.6.0/images/flag-icon-css/4x3/sa.svg',
  },
  {
    name: 'Armenian',
    code: 'hy',
    flag:
      'https://cdn.jsdelivr.net/gh/weglot/languages@1.6.0/images/flag-icon-css/4x3/am.svg',
  },
  {
    name: 'Khmer (Cambodian)',
    code: 'km',
    flag:
      'https://cdn.jsdelivr.net/gh/weglot/languages@1.6.0/images/flag-icon-css/4x3/kh.svg',
  },
  {
    name: 'Chinese Simplified',
    code: 'zh',
    flag:
      'https://cdn.jsdelivr.net/gh/weglot/languages@1.6.0/images/flag-icon-css/4x3/cn.svg',
  },
  {
    name: 'Chinese Traditional',
    code: 'tw',
    flag:
      'https://cdn.jsdelivr.net/gh/weglot/languages@1.6.0/images/flag-icon-css/4x3/tw.svg',
  },
  {
    name: 'Farsi',
    code: 'fa',
    flag:
      'https://cdn.jsdelivr.net/gh/weglot/languages@1.6.0/images/flag-icon-css/4x3/ir.svg',
  },
  {
    name: 'Hmong',
    code: 'hm',
    flag:
      'https://cdn.jsdelivr.net/gh/weglot/languages@1.6.0/images/flag-icon-css/4x3/hm.svg',
  },
  {
    name: 'Korean',
    code: 'ko',
    flag:
      'https://cdn.jsdelivr.net/gh/weglot/languages@1.6.0/images/flag-icon-css/4x3/kr.svg',
  },
  {
    name: 'Russian',
    code: 'ru',
    flag:
      'https://cdn.jsdelivr.net/gh/weglot/languages@1.6.0/images/flag-icon-css/4x3/ru.svg',
  },
  {
    name: 'Spanish',
    code: 'es',
    flag:
      'https://cdn.jsdelivr.net/gh/weglot/languages@1.6.0/images/flag-icon-css/4x3/es.svg',
  },
  {
    name: 'Tagalog',
    code: 'tl',
    flag:
      'https://cdn.jsdelivr.net/gh/weglot/languages@1.6.0/images/flag-icon-css/4x3/in.svg',
  },
  {
    name: 'Vietnamese',
    code: 'vi',
    flag:
      'https://cdn.jsdelivr.net/gh/weglot/languages@1.6.0/images/flag-icon-css/4x3/vn.svg',
  },
]